import Vue from 'vue'
import DownloadableResources from 'js/components/downloadable-resources'

import template from './index.pug'

// @vue/component
export default Vue.extend({
  template: template(),

  components: {DownloadableResources},
  mounted(){
    this.customAccesibilityTabs.setup(this.$options.name)
  }
})
